import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Role } from '../models/role';


@Injectable({
  providedIn: 'root',
})
export class UserAuthService {
  public keyName: string = environment.userInfo_LocalStoreKey;

  constructor() {}

  public save(userData: Object) {
    localStorage.setItem(this.keyName, JSON.stringify(userData));
  }

  public saveLoginData(userData: Object) {
    localStorage.setItem(this.keyName, JSON.stringify(userData));
  }

  public load() {
    try {
      let storedData: string = localStorage.getItem(this.keyName);
      if (!storedData) {
        throw Error('no user data found');
      }
      return JSON.parse(storedData);
    } catch (e) {}
    return null;
  }

  public clear() {
    localStorage.removeItem(this.keyName);
    localStorage.removeItem('patient');
    localStorage.removeItem('notes');
    localStorage.removeItem('speciality');
    localStorage.removeItem('selectNotes');
    localStorage.removeItem('email');
    localStorage.removeItem('validacionSms');
    localStorage.removeItem('userData');
    localStorage.removeItem('openDataUser');
    localStorage.clear();
  }

  public isAuthenticated() {
    let data: string = this.load();
    let loggedIn: boolean = false;
    if (data !== null) {
      try {
        if (!data['token']) {
          return false;
        }
        loggedIn = this.getUser() != null;
      } catch (e) {
        console.error(e);
      }
    }
    return loggedIn;
  }

  public isShow() {
    let loggedIn: boolean = false;
    try {
      let data: string = this.load();
      if (data != null) {
        if (localStorage.getItem("temporaryScreen") == "1" || data['token']) {
          return true;
        } else {
          return false;
        }
      }
    } catch (e) {
      console.error(e);
    }
    return loggedIn;
  }

  public useMargin() {
    let loggedIn: boolean = false;
    try {
      let data: string = this.load();
      
      if (data != null && data['token'] != null && 
      (localStorage.getItem("temporaryScreen") == undefined || 
      localStorage.getItem("temporaryScreen") == "" || 
      localStorage.getItem("temporaryScreen") == "0")) {
        return false;
      } else {
        return true;
      }
    } catch (e) {
      console.error(e);
    }
    return loggedIn;
  }

  getUser(): any {
    try {
      return JSON.parse(localStorage.getItem(this.keyName));
    } catch (e) {}
    return null;
  }

  getUserId(): any {
    try {
      return JSON.parse(localStorage.getItem('loggedInID'));
    } catch (e) {}
    return null;
  }

  public getReason(): string | null {
    try {
      return localStorage.getItem('reason');
    } catch (e) {}
    return null;
  }

  public getDocumentNumber(): string | null {
    const user = this.getUser();
    return user?.docNumber ?? null;
  }

  public hasOpenData(): boolean | null {
    const user = this.getUser();
    return user?.openData ?? null;
  }

  public getCategoryCompany(): string | null {
    const user = this.getUser();
    return user?.categoryCompany ?? null;
  }

  public getCompanyId(): number | null {
    const user = this.getUser();
    return user?.idCompany ?? null;
  }

  public getLocalId(): number | null {
    const user = this.getUser();
    return user?.idLocal ?? null;
  }

  public getToken(): string {
    return this.load().token;
  }

  public getRoles(): string[] {
    const user = this.getUser();
    if (!user || !user.roles) return [];
    const normalized = user.roles.map((r: string) => r.toLowerCase().trim());
    // console.log('Normalized roles:', normalized);
    return normalized;
  }

  public hasRole(role: string): boolean {
    return this.getRoles().includes(role.toLowerCase().trim());
  }

  public hasAnyRole(...roles: string[]): boolean {
    const userRoles = this.getRoles();
    return roles.some(r => userRoles.includes(r.toLowerCase().trim()));
  }

  public isCompanyAdmin(): boolean {
    return this.hasAnyRole(Role.AdminGeneralCompany, Role.AdminLocalCompany);
  }

  public isLab(): boolean {
    return this.hasRole(Role.Lab);
  }

  public isAdmin(): boolean {
    return this.hasAnyRole(Role.SuperAdmin, Role.AdminGeneralCompany, Role.AdminLocalCompany);
  }

  public isMedical(): boolean {
    return this.hasAnyRole(Role.Medic, Role.Nurse);
  }

  public isPatient(): boolean {
    return this.hasRole(Role.Patient);
  }

  public isPharmacist(): boolean {
    return this.hasRole(Role.Pharmacist);
  }

  public isAdmissionsClerk(): boolean {
    return this.hasRole(Role.AdmissionsClerk);
  }


}
